import { render, staticRenderFns } from "./SettlementBOEditor.vue?vue&type=template&id=7256ff40&"
import script from "./SettlementBOEditor.vue?vue&type=script&lang=js&"
export * from "./SettlementBOEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports